import { create } from 'zustand';

// Loader global untuk proses translasi: kamus bahasa diambil dari backend
// (cm_language) saat bootstrap aplikasi dan saat ganti bahasa EN/ID - proses
// ini bisa lama, dan tanpa loader UI terlihat beku/berbahasa campur.
// Dipakai lewat useLoadingStore.getState().setTranslationLoading(...) dari
// kode non-React (i18n helpers) dan lewat hook dari komponen.
interface LoadingState {
  translationLoading: boolean;
  setTranslationLoading: (value: boolean) => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  translationLoading: false,
  setTranslationLoading: (value) => set({ translationLoading: value }),
}));
